class VariantSelects extends HTMLElement {

  constructor() {
    super();

    // Options
    this.options = {}

    // Get options from element data and combine with this.options
    if (this?.dataset?.options) {
      const dataOptions = JSON.parse(this.dataset.options);
      this.options = {
        ...this.options,
        ...dataOptions
      };
    }

    // Selectors
    this.media = document.querySelector('[data-product-media');
    this.mediaMobile = document.querySelector('[data-product-media-swiper]');

    // Cache media data
    if (this.media && this.options.variant && this.options.handle) {
      this.mediaData = [{
        id: parseInt(this.options.variant),
        html: this.media.innerHTML
      }];
    }

    if (this.mediaMobile && this.options.variant && this.options.handle) {
      this.mediaMobileData = [{
        id: parseInt(this.options.variant),
        html: this.mediaMobile.innerHTML
      }];
    }

    // Variant change listener
    this.onVariantChange();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.toggleAddButton(false, '', false);
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.dispatchVariantChange();
    }
  }

  updateOptions() {
    this.variantOptions = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.variantOptions[index] === option;
      }).includes(false);
    });
  }

  dispatchVariantChange() {
    document.dispatchEvent(
      new CustomEvent(
        'variant-change',
        {
          bubbles: true,
          variant: this.currentVariant,
          detail: {
            variant: this.currentVariant
          }
        }
      )
    );
  }

  async updateMedia() {
    if (!this.currentVariant || !this.media || !this.options.variant || !this.options.handle) {
      return;
    }
    const html = await this.getMedia(this.currentVariant.id);

    this.media.innerHTML = html[0].desktop;
    this.mediaMobile.innerHTML = html[0].mobile;
  }

  async getMedia(id) {
    // Check for cached data
    const item = this.mediaData.find((item) => item.id == parseInt(id));
    const itemMobile = this.mediaMobileData.find((item) => item.id == parseInt(id));

    // Fetch data if not in cache
    if (!item && !itemMobile) {
      let data = await fetch(`/products/${this.options.handle}?view=media&variant=${id}`, this.fetchConfig());
      data = await data.text();
      let html = new DOMParser().parseFromString(data, 'text/html').querySelector('[data-product-media]').innerHTML;
      let htmlMobile = new DOMParser().parseFromString(data, 'text/html').querySelector('[data-product-media-swiper]').innerHTML;

      // Cache fetch
      this.mediaData.push({
        id: id,
        html: html
      });

      // Cache fetch
      this.mediaMobileData.push({
        id: id,
        html: htmlMobile
      });

      return [{
        desktop: html,
        mobile: htmlMobile
      }];
    }

    return [{
      desktop: item.html,
      mobile: itemMobile.html
    }];
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const ids = [
          `price-${this.dataset.section}-mobile`,
          `price-${this.dataset.section}`,
          `sku-${this.dataset.section}-mobile`,
          `sku-${this.dataset.section}`,
          `dimensions-${this.dataset.section}`
        ];
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        ids.forEach((id) => {
          const destination = document.getElementById(id);
          const source = html.getElementById(id);

          if (source && destination) destination.innerHTML = source.innerHTML;
        });

        document.getElementById(`price-${this.dataset.section}-mobile`)?.classList.remove('product__price--hidden');
        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('product__price--hidden');

        if (this.currentVariant) {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        }

        // Update the inventory quantity hidden input
        const inventoryQtyDestination = document.querySelector(`#product-form-${this.dataset.section}`).querySelector('input[name="inventory_quantity"]');
        const inventoryQtySource = html.querySelector(`#product-form-${this.dataset.section}`).querySelector('input[name="inventory_quantity"]');
        inventoryQtyDestination.value = inventoryQtySource.value;
      });
  }

  /**
   * toggleAddButton
   * @param {Boolean} disable
   * @param {String} text
   * @param {Boolean} modifyClass
   * @returns {void}
   */
  toggleAddButton(disable = true, text, modifyClass = true) {

    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('[data-add-to-cart-button-text]');

    if (!addButton || !addButtonText) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.innerHTML = `<span data-add-to-cart-button-text>${window.variantStrings.unavailable}</span>`;
    document.getElementById(`price-${this.dataset.section}-mobile`)?.classList.add('product__price--hidden');
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('product__price--hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  // Fetch config
  fetchConfig() {
    return {
      method: 'GET',
      headers: { 'Content-Type': 'text/html'}
    };
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  onVariantChange() {
    super.onVariantChange();
    this.updateLabels();
    this.highlightOptions();
  }

  /*
   * Update variant group labels (size/color)
  */
  updateLabels() {
    if (!this.currentVariant) {
      return false;
    }

    // Loop over option groups
    this.querySelectorAll('[data-option]').forEach((option) => {

      // Get index from option group (1, 2 or 3)
      const optionIndex = parseInt(option.dataset.option);

      // Update label with value
      option.querySelector('[data-options-label]').innerHTML = this.variantOptions[optionIndex];
    });
  }

  /*
   * Check for each option value if the other one/two selected variant options are available
   */
  highlightOptions() {

    // If no selected element make all available
    let selectedElement = event ? event.target : this.querySelector('[data-option]').querySelector('input[checked]');
    if (!selectedElement) {
      this.querySelectorAll('[data-option]').forEach((option) => {
        option.querySelectorAll('input[type="radio"]').forEach((optionValue) => optionValue.classList.remove('disabled'));
      });
      return;
    }

    // Loop over option groups
    this.querySelectorAll('[data-option]').forEach((option) => {

      // Get index from option group (1, 2 or 3)
      const optionIndex = parseInt(option.dataset.option);

      // Create compare options from group, remove selected option based on index
      const compareOptions = [...this.variantOptions].filter((option, index) => index != optionIndex);

      // Loop over possible values for option group
      option.querySelectorAll('input[type="radio"]').forEach((optionValue) => {
        let value = optionValue.value;

        // Match option availability and check if the two current options are available for value
        let match = this.getVariantData().filter(variant => {

          // Get available variants where the current option index is the option value
          if (variant.options[optionIndex] == value && variant.available) {

            // Create variant options, remove option based on option value
            const variantOptions = [...variant.options].filter((option, index) => index != optionIndex);

            // Check if compare options is the same as variant options
            return variantOptions.every((item, index) => item.toLowerCase() === compareOptions[index].toLowerCase());

          }

          return false;
        });

        // Debug current index, current value, compare options and match
        // console.log(optionIndex, value, compareOptions, match);

        // Enable disable variant options
        optionValue.classList.toggle('disabled', match.length == 0);
      });

    });

  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.variantOptions = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}

